"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _FilterProcessor2 = _interopRequireDefault(require("./FilterProcessor"));

var _Filters = _interopRequireDefault(require("../../../models/transform/filter/Filters"));

var _Filter = _interopRequireDefault(require("../../../models/transform/filter/Filter"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ContextFilterProcessor = /*#__PURE__*/function (_FilterProcessor) {
  (0, _inherits2["default"])(ContextFilterProcessor, _FilterProcessor);

  var _super = _createSuper(ContextFilterProcessor);

  function ContextFilterProcessor() {
    (0, _classCallCheck2["default"])(this, ContextFilterProcessor);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ContextFilterProcessor, [{
    key: "applyFilters",
    value: function applyFilters(layerId, layerBitmap, bitmapDimensions, canvasContext, filters, safeOutputDimensions) {
      if (!_Filters["default"].isFilters(filters)) {
        canvasContext.filter = _Filter["default"].NONE;
        return layerBitmap;
      } // Apply filter to canvas context


      canvasContext.filter = filters.toCanvasString();
      return layerBitmap;
    }
  }]);
  return ContextFilterProcessor;
}(_FilterProcessor2["default"]);

exports["default"] = ContextFilterProcessor;